const router = [
  {
    name: 'member',
    path: '/member',
    meta: {
      title: '会员管理',
      icon: 'user'
    }
  },
  {
    name: 'MemberList',
    path: '/member/list',
    component: () => import('/@/views/member/MemberList.vue'),
    meta: { title: '会员列表' }
  },
  {
    name: 'MemberLevel',
    path: '/member/level',
    component: () => import('/@/views/member/MemberLevel.vue'),
    meta: { title: '会员等级' }
  }
]
export default router
